import React, { useEffect, useState } from 'react';
import Container from '../Container/Container';
import { useNavigate, useLocation } from 'react-router';
import { get } from '../ApiServices/ApiServices';
import DeleteButton from './Component/DeleteFun';
// import Loader from '../Loader/Loader'; // Import the Loader component
import Loader from './Component/Loader';
import { useDispatch, useSelector } from 'react-redux';

function MapAffiliated() {
  const [Groups, setGroups] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Add loading state
  const [singledata, setsingledata] = useState([])
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [SingleCustomers, setSingleCustomers] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  console.log(location, "location");
  const profile = useSelector((state) => state.profile.profile);
  console.log(profile?.name == "Admin", "profileprofile");
  const ViewGroups = async (search = '', size = itemsPerPage, page_number = currentPage) => {
    setIsLoading(true); // Set loading to true before fetching data
    try {
      const api = profile?.name === "Admin"
        ? `all-groups?search=${search}&size=${size}&page_number=${page_number}`
        : `all-group-customers/${profile?.id}?search=${search}&page_number=${page_number}`;

      const totalData = await get(api);

      if (profile?.name === "Admin") {
        setGroups(totalData?.data?.rows);
        setTotalItems(totalData?.data?.count);
      } else {
        setGroups(totalData?.data?.rows);
        setTotalItems(totalData?.data?.count);

      }
    } catch (err) {
      if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
        localStorage.removeItem('token');
        navigate('/login');
      }
      console.error('Error fetching profile data:', err);
    } finally {
      setIsLoading(false); // Set loading to false after fetching data
    }
  };



  useEffect(() => {
    ViewGroups(searchTerm, itemsPerPage, currentPage);
  }, [searchTerm, itemsPerPage, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    ViewGroups(searchTerm, itemsPerPage, page);
  };

  const handleItemsPerPageChange = (e) => {
    const newSize = parseInt(e.target.value, 10);
    setItemsPerPage(newSize);
    setCurrentPage(1);
    ViewGroups(searchTerm, newSize, 1);
  };

  const handleSearchChange = (e) => {
    const newSearchTerm = e.target.value;
    setSearchTerm(newSearchTerm);
    setCurrentPage(1);
    ViewGroups(newSearchTerm, itemsPerPage, 1);
  };

  const handleDeleteSuccess = () => {
    ViewGroups(searchTerm, itemsPerPage, currentPage);
  };

  const ViewCustomers = async (id) => {
    try {
      setIsModalLoading(true);
      const api = `view-customer/${id}`;
      const totalData = await get(api);

      if (totalData?.status === true) {
        setSingleCustomers(totalData.data);
      }
    } catch (err) {
      if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
        localStorage.removeItem('token');
        navigate('/login');
      }
      console.error('Errordsfdsfd:', err);
    } finally {
      setIsModalLoading(false);
    }
  };

  return (
    <Container>
      <div class="nk-content ">
        <div class="container-fluid">
          <div class="nk-content-inner">
            <div class="nk-content-body">
              <div class="nk-block-head nk-block-head-sm pbZeroHeadin">
                <div class="nk-block-between">
                  <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">Alternate Pickup Locations</h3></div>
                  <div class="nk-block-head-content">
                    <div class="toggle-wrap nk-block-tools-toggle">
                      <div class="toggle-expand-content">
                        <ul class="nk-block-tools g-3">
                          {
                            profile?.name == "Admin" &&
                            <>
                              <li class="nk-block-tools-opt">
                                <a className="btn btn-primary" onClick={(e) => {
                                  e.preventDefault();
                                  navigate('/add-affiliated-group/create');
                                }}>
                                  <span>Add New Group</span>
                                </a>
                              </li>
                              <li class="nk-block-tools-opt">
                                <a class="btn btn-outline-secondary" onClick={(e) => {
                                  e.preventDefault();
                                  navigate('/add-affiliated-group/assign');
                                }}><span>Assign Group</span></a>
                              </li>
                            </>
                          }

                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card card-full">
                <div class="card-inner">
                  <div class="card-title-group mb-3">
                    <div class="card-tools">
                      <div class="form-control-wrap">
                        <div class="form-icon form-icon-right"><em class="icon ni ni-search"></em></div>
                        <input
                          type="text"
                          class="form-control"
                          id="default-04"
                          placeholder="Search by keywords"
                          value={searchTerm}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </div>
                  </div>

                  <h5>{profile?.name === "Admin" ? "Stores" : "Affiliated Stores"}</h5>
                  {isLoading ? ( // Conditionally render the Loader
                    <Loader />
                  ) : (
                    <div className="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          {/* <tr>
                            <th scope="col">{profile?.name === "Admin" ? "Group" : "stores"}</th>
                            <th scope="col">Action</th>
                          </tr> */}
                          <tr>
                            {profile?.name === "Admin" ? (
                              <>
                                <th scope="col">Group</th>
                                <th scope="col">Action</th>
                              </>
                            ) : (
                              <>
                                <th scope="col">Acct #</th>
                                <th scope="col">Company Name</th>
                                <th scope="col">Owner</th>
                                <th scope="col">Affiliated Store</th>
                                <th scope="col">Phone</th>
                                <th scope="col">Email</th>
                                <th scope="col">Action</th>
                              </>
                            )}
                          </tr>
                        </thead>

                        <tbody>
                          {Groups.length > 0 ? Groups.map((data) => {
                            return (
                              <tr key={data.id}>
                                {profile?.name === "Admin" ? (
                                  <>
                                    <th scope="row">{data?.name}</th>
                                    <td className="tableActionBtn">
                                      <a className="editPen" style={{ cursor: "pointer" }} onClick={() => {
                                        navigate(`/update-affiliated-group`, { state: { id: data?.id } })
                                      }}>
                                        <em className="icon ni ni-edit-alt"></em>
                                      </a>
                                      <span className="deleteTrash" style={{ cursor: "pointer" }} onClick={() => { navigate(`/affiliated-detail`, { state: { id: data?.id } }) }}>
                                        <em className="icon ni ni-eye"></em>
                                      </span>
                                      <DeleteButton url={`delete-group/${data?.id}`} onDeleteSuccess={handleDeleteSuccess} />
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    <td>{data?.account || 'N/A'}</td>
                                    <td>{data?.companyName || 'N/A'}</td>
                                    <td>{data?.firstName || 'N/A'} {data?.lastName}</td>
                                    <td>{data?.affiliatedStore || 'N/A'}</td>
                                    <td>{data?.phone || 'N/A'}</td>
                                    <td>{data?.email || 'N/A'}</td>
                                    <td className="tableActionBtn">
                                      <button className="deleteTrash" data-bs-toggle="modal" data-bs-target="#viewCusDetailModal" onClick={() => { ViewCustomers(data?.id) }} style={{ cursor: "pointer" }}>
                                        <em className="icon ni ni-eye"></em>
                                      </button>
                                    </td>
                                  </>
                                )}
                              </tr>
                            )
                          }) : (
                            <tr>
                              <td colSpan={profile?.name === "Admin" ? "2" : "7"} className="text-center">
                                <div className="data-not-found">
                                  <em className="icon ni ni-info"></em>
                                  <p>No data available</p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>

                      </table>
                    </div>
                  )}
                  {
                    profile?.name == "Admin" &&
                    Groups.length > 0 &&
                    <div class="nk-block-between-md g-3 mt-3">
                      <div class="g">
                        <div class="pagination d-flex gap-2" style={{ height: "35px" }}>
                          <button
                            className={`btn btn-sm ${currentPage === 1 ? 'btn-disabled' : 'btn-primary'}`}
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            Previous
                          </button>

                          {Array.from({ length: Math.ceil(totalItems / itemsPerPage) }, (_, i) => (
                            <button
                              key={i + 1}
                              className={`btn btn-sm ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                              onClick={() => handlePageChange(i + 1)}
                            >
                              {i + 1}
                            </button>
                          )).slice(Math.max(0, currentPage - 3), Math.min(currentPage + 2, Math.ceil(totalItems / itemsPerPage)))}

                          <button
                            className={`btn btn-sm ${currentPage === Math.ceil(totalItems / itemsPerPage) ? 'btn-disabled' : 'btn-primary'}`}
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                      {
                        Groups.length >= 10 &&
                        <div class="g">
                          <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
                            <div>Showing</div>
                            <div>
                              <select
                                className="form-select js-select2"
                                value={itemsPerPage}
                                onChange={handleItemsPerPageChange}
                              >
                                {totalItems >= 10 && <option value="10">10</option>}
                                {totalItems >= 20 && <option value="20">20</option>}
                                {totalItems >= 50 && <option value="50">50</option>}
                                {totalItems >= 100 && <option value="100">100</option>}
                              </select>
                            </div>
                            <div>of {totalItems} items</div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="modal fade" tabindex="-1" id="viewCusDetailModal">
        <div className="modal-dialog modal-lg" role="document"> {/* Increased modal size */}
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">View store Detail</h5>
              <a href="#" className="close" data-bs-dismiss="modal" aria-label="Close">
                <em className="icon ni ni-cross-c"></em>
              </a>
            </div>
            <div className="modal-body inputCardBox">
              {isModalLoading ? (
                <Loader />
              ) : (
                <div className="row">
                  {/* Use col-md-6 for two columns per row */}
                  <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>ID:</span>
                      <span className="wrap-text">{SingleCustomers?.id || 'N/A'}</span>
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Acct#:</span>
                      <span className="wrap-text">{SingleCustomers?.account || 'N/A'}</span>
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Company name:</span>
                      <span className="wrap-text">{SingleCustomers?.companyName || 'N/A'}</span>
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Email:</span>
                      <span className="wrap-text">{SingleCustomers?.email || 'N/A'}</span>
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Phone:</span>
                      <span className="wrap-text">{SingleCustomers?.phone || 'N/A'}</span>
                    </div>
                  </div>
                  {/* <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Name:</span>
                      <span className="wrap-text">{SingleCustomers?.firstName} {SingleCustomers?.lastName}</span>
                    </div>
                  </div> */}
                  {/* <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Fax:</span>
                      <span className="wrap-text">{SingleCustomers?.fax || 'N/A'}</span>
                    </div>
                  </div> */}
                  {/* <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Shipping Address:</span>
                      <span className="wrap-text">
                        {SingleCustomers?.addresses[0]?.shippingAddress || 'N/A'} {SingleCustomers?.addresses[0]?.shippingCity || ''} {SingleCustomers?.addresses[0]?.shippingState || ''} {SingleCustomers?.addresses[0]?.shippingZip || ''}
                      </span>
                    </div>
                  </div> */}
                  <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Billing Address:</span>
                      <span className="wrap-text">
                        {SingleCustomers?.addresses[0]?.billingAddress || 'N/A'} {SingleCustomers?.addresses[0]?.billingCity || ''} {SingleCustomers?.addresses[0]?.billingState || ''} {SingleCustomers?.addresses[0]?.billingZip || ''}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Owner:</span>
                      <span className="wrap-text">{SingleCustomers?.firstName} {SingleCustomers?.lastName}</span>
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Alternate Pickup Location:</span>

                      <span className="wrap-text"> {SingleCustomers?.isAltPickupEnable == true ? "Enable" : "Disable" || 'N/A'}</span>
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Affiliated store:</span>
                      <span className="wrap-text">{SingleCustomers?.affiliatedStore || 'N/A'}</span>
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="detailList">
                      <span>Drop Shipping:</span>
                      <span className="wrap-text">{SingleCustomers?.isDropShipEnable == true ? "Enable" : "Disable" || 'N/A'}</span>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default MapAffiliated;